<span class="ds-text-body-s-semi-bold">Solicitud de Pensión por Invalidez</span>
<h2 class="ds-text-h2-l-bold">Paso 2: Tu información</h2>
<span class="ds-text-body-regular">
    Revisa con atención la información que tenemos sobre ti</span>

<div class="invalidez-personal-data-container">
    <ds-card class="card-content" size="m" background="#ffffff" shadow="l2">
        <h3 class="ds-text-h3-s-bold">Datos personales</h3>
        <p class="ds-text-body-s-regular">Puedes editar estos datos agendando una <button type="button" class="link"
                (click)="goToVideoAtencion()">
                Video Atención.
            </button></p>

        <ds-card background="var(--ds-foundation-colors-neutral-100)" shadow="none">
            <div id="datosPersonales" class="div-personal-data">
                <div class="div-data">
                    <div class="descripcion">Nombre:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.name">
                            {{ personalData?.name || "Aún no registras tu nombre" }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Apellido:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.lastName">
                            {{ personalData?.lastName || "Aún no registras tu apellido" }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Rut:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.rut">
                            {{ personalData?.rut || "Aún no registras tu rut" }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Sexo:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.gender">
                            {{ personalData?.gender || "Aún no registras tu sexo" }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Fecha de nacimiento:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.birthDate">
                            {{
                            personalData?.birthDate ||
                            "Aún no registras tu fecha de nacimiento"
                            }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Estado civil:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.civilStatus">
                            {{
                            personalData?.civilStatus || "Aún no registras tu estado civil"
                            }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
            </div>
        </ds-card>

    </ds-card>

    <ds-card class="card-content" shadow="l2" gap="var(--ds-foundation-spacing-xs)">
        <h3 class="ds-text-h3-s-bold">Datos de contacto</h3>
        <p class="ds-text-body-s-regular">Si deseas actualizar tus datos de contacto, puedes hacerlo en <button
                type="button" aria-label="Si deseas actualizar tus datos de contacto, puedes hacerlo en Tus Datos."
                class="link" (click)="goToYourData()">
                Tus Datos.
            </button></p>


        <ds-card background="var(--ds-foundation-colors-neutral-100)" shadow="none" backgroundOpacity="strong">
            <div class="div-personal-data">
                <div class="div-data">
                    <div class="descripcion">Domicilio:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.address">
                            {{ personalData?.address || "Aún no registras tu domicilio" }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Teléfono:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.phoneNumber">
                            {{
                            personalData?.phoneNumber
                            ? "+569" + personalData.phoneNumber
                            : "Aún no registras tu teléfono"
                            }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
                <div class="div-data">
                    <div class="descripcion">Correo:</div>
                    <ng-container *ngIf="!loadingPersonalData">
                        <div class="value" [class.sinRegistro]="!personalData?.email">
                            {{ personalData?.email || "Aún no registras tu correo" }}
                        </div>
                    </ng-container>
                    <ds-skeleton variant="text" class="value" *ngIf="loadingPersonalData" />
                </div>
            </div>
        </ds-card>
    </ds-card>

    <ds-card class="card-content" shadow="l2" gap="var(--ds-foundation-spacing-xs)">
        <h3 class="ds-text-h3-s-bold">Saldos obligatorios</h3>
        <p class="ds-text-body-s-regular"> Si deseas puedes realizar un
            <button type="button" class="link" (click)="goToFundChange()">
                Cambio de fondos.
            </button>
        </p>

        <ds-table [columns]="columnsSaldosObligatorios" [rows]="balances" [rowKey]="rowKeyBalance" [itemsPerPage]="10"
            [expandedByDefault]="true" [allowMultipleExpanded]="false" responsiveMode="key-value" appearance="filled"
            [divider]="true" size="xs" [responsiveBreakpoint]="431" [responsive]="true">
        </ds-table>

        <ds-skeleton variant="card" *ngIf="balances && balances.length === 0" />
    </ds-card>

    <ds-card class="card-content" shadow="l2" gap="var(--ds-foundation-spacing-xs)">
        <h3 class="ds-text-h3-s-bold">Tus Beneficiarios</h3>
        <p class="ds-text-body-s-regular"> Puedes agregar o modificar tus personas beneficiarias desde
            <button type="button"
                aria-label="Puedes agregar o modificar tus personas beneficiarias desde actualizar tus beneficiarios."
                class="link" (click)="goToYourBeneficiaries()">
                actualizar tus beneficiarios.
            </button>
        </p>

        <ds-table *ngIf="!loadingBeneficiaries" [columns]="columnsBeneficiarios" [rows]="beneficiaries"
            [rowKey]="rowKeyBeneficiario" [itemsPerPage]="10" [expandedByDefault]="true" [allowMultipleExpanded]="false"
            responsiveMode="key-value" appearance="filled" [divider]="true" size="xs" [responsiveBreakpoint]="431"
            [responsive]="true">
        </ds-table>

        <ds-skeleton variant="card" *ngIf="loadingBeneficiaries" />

        <ds-inline-alert type="info" emphasis="outline" size="s" *ngIf="beneficiaries && beneficiaries.length > 0"
            description="Los hijos deben ser solteros para ser beneficiarios. Si alguno ya no lo es, quítalo de la lista para continuar." />
    </ds-card>

    <app-pi-document-upload (btnDisableChange)="documentosIncompletos = $event"></app-pi-document-upload>

    <ds-card class="card-content" size="m" background="#ffffff" shadow="l2">
        <h3 class="ds-text-h3-s-bold">Para continuar, por favor confirma lo siguiente:</h3>

        <ds-card background="var(--ds-foundation-colors-neutral-100)" shadow="none" backgroundOpacity="strong">
            <div class="pi-confirmacion__panel">
                <div class="pi-confirmacion__check-row">
                    <ds-check [checked]="checkCondicionesBeneficiario"
                        ariaLabel="Declaración de soltería: Confirmo que los beneficiarios son solteros"
                        (checkedChange)="checkCondicionesBeneficiario = $event">
                    </ds-check>
                    <span class="pi-confirmacion__check-text">
                        Declaración de soltería: Confirmo que los beneficiarios son solteros.
                    </span>
                </div>

                <div class="pi-confirmacion__check-row">
                    <ds-check [checked]="checkCondicionesDatosPersonales"
                        ariaLabel="Leí con atención mis datos personales y confirmo que son correctos. Entiendo que, si algún dato es erróneo, mi trámite podría tener demoras."
                        (checkedChange)="checkCondicionesDatosPersonales = $event">
                    </ds-check>
                    <span class="pi-confirmacion__check-text">
                        Leí con atención mis datos personales y confirmo que son correctos. Entiendo que, si algún dato
                        es erróneo, mi trámite podría tener demoras.
                    </span>
                </div>
            </div>
        </ds-card>
    </ds-card>

    <div class="pi-confirmacion__container">
        <ds-button-v2 label="Continuar" emphasis="primary" size="m" fullWidth [maxWidth]="320" [loading]="loading"
            [disabled]="documentosIncompletos || !checkCondicionesBeneficiario || !checkCondicionesDatosPersonales"
            (clicked)="continue()">
        </ds-button-v2>
    </div>

</div>